export const MarkdownStorageKey = 'markdown';
